import { Picture, PICTURE_ORIGIN } from '../../../../domains/Picture/Picture';

export type PublicPictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['publicPicture'];
    id: number;
    author: string;
    legend: string;
};

export type PrismicPictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['publicPicture'];
    author: string;
    legend: string;
    pictures: Array<{ url: string | undefined; width: number; height: number }>; //TODO: check with backend for undefined value
};

export type OfferManagerPictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['offerManager'];
    path: string;
    copyright: string;
};

export type PublicWebsiteContentPictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['publicWebsiteContent'];
    path: string;
    author: string;
    legend: string;
};

export type DamImagePictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['damImage'];
    id: number;
    author: string;
    legend: string;
};

export type UgcPictureFromApi = {
    origin: (typeof PICTURE_ORIGIN)['ugc'];
    path: string;
};

export function normalizePicture(
    picture:
        | PublicPictureFromApi
        | OfferManagerPictureFromApi
        | PublicWebsiteContentPictureFromApi
        | DamImagePictureFromApi
        | UgcPictureFromApi,
): Picture {
    if (picture.origin === PICTURE_ORIGIN.offerManager) {
        return {
            origin: PICTURE_ORIGIN.offerManager,
            id: picture.path,
            author: picture.copyright,
            legend: '', // Images coming from Offer Manager don't have any alt attribute, therefore we fill legend with an empty string
        };
    }

    if (picture.origin === PICTURE_ORIGIN.publicWebsiteContent) {
        return {
            origin: PICTURE_ORIGIN.publicWebsiteContent,
            id: picture.path,
            author: picture.author,
            legend: picture.legend,
        };
    }

    if (picture.origin === PICTURE_ORIGIN.ugc) {
        return {
            origin: PICTURE_ORIGIN.ugc,
            id: picture.path,
            author: '',
            legend: '',
        };
    }

    return {
        origin: PICTURE_ORIGIN.publicPicture,
        id: picture.id.toString(),
        author: picture.author,
        legend: picture.legend,
    };
}
